/**
 * Shared vocabulary for menu dietary tags and allergens.
 *
 * Stored on `menu_items` as `dietaryTags` / `allergens` and synced one-way into the customer app
 * (Kingspark-mobile `syncPosMenu` → `menuItems.tags` / `.allergens`), where they drive the menu's
 * dietary filter chips and the allergy warnings matched against a customer's saved allergies.
 * Keep ids stable — the app matches on them.
 */

export type DietaryTag = 'vegetarian' | 'vegan' | 'gluten_free' | 'dairy_free' | 'nut_free' | 'halal';

export const DIETARY_TAGS: { id: DietaryTag; label: string }[] = [
  { id: 'vegetarian', label: 'Vegetarian' },
  { id: 'vegan', label: 'Vegan' },
  { id: 'gluten_free', label: 'Gluten-free' },
  { id: 'dairy_free', label: 'Dairy-free' },
  { id: 'nut_free', label: 'Nut-free' },
  { id: 'halal', label: 'Halal' },
];

/** Common allergens (NZ/AU FSANZ mandatory declarations). Free text is still allowed. */
export const COMMON_ALLERGENS: string[] = [
  'Gluten',
  'Dairy',
  'Egg',
  'Peanuts',
  'Tree nuts',
  'Sesame',
  'Soy',
  'Fish',
  'Shellfish',
  'Lupin',
  'Sulphites',
];
